import React from 'react';
import Head from 'react-helmet';

import { useLocation } from 'react-router-dom';
import { useNodeEnv } from '../hooks';

export type HeadWrapperProps = {
  description?: string;
  noFollow?: boolean;
  noIndex?: boolean;
  title?: string;
  useStrictTitle?: boolean;
};

export const HeadWrapper = ({
  description: customDescription = '',
  noFollow = false,
  noIndex = false,
  title: pTitle = '',
  useStrictTitle = false,
}: HeadWrapperProps) => {
  const { hostname } = useNodeEnv();
  const location = useLocation();
  const displayBrand = 'Zillow Rental Manager';
  const defaultDescription =
    `Use ${displayBrand} to manage applications, screen tenants, ` +
    'collect rent and list your rental property on Zillow, Trulia and HotPads.';
  // Grabs custom meta description, if present OR grabs default description provided above
  const content = customDescription || defaultDescription;

  const title = useStrictTitle ? pTitle : `${pTitle} | ${displayBrand}`;

  const link: Array<{ rel: string; href: string }> = [];

  // default meta data
  const meta = [
    {
      name: 'description',
      content,
    },
  ];

  // remove any query params (? and &)
  const href = `${hostname}${location.pathname}`.split('?')[0].split('&')[0];

  const getRobotMetaContent = () => {
    const robotContentList: Array<string> = [];

    if (noIndex) {
      robotContentList.push('noindex');
    }

    if (noFollow) {
      robotContentList.push('nofollow');
    }

    return robotContentList.join(', ');
  };

  // set canonical link
  link.push({
    rel: 'canonical',
    href,
  });

  meta.push({
    name: 'robots',
    content: getRobotMetaContent(),
  });

  return <Head meta={meta} title={title} link={link} />;
};
